import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Box
} from '@mui/material';
import PrimaryButton from "../Common/PrimaryButton.tsx";
import {ComponentConfig} from "../../Config/ComponentConfig";

interface ReopenQueryDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ReopenQueryDialog = ({open, onClose, onConfirm}: ReopenQueryDialogProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                elevation: 4,
                sx: {
                    borderRadius: 3,
                    px: 1,
                    py: 1.5
                }
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: 'center',
                    fontWeight: 600,
                    fontSize: '1.25rem',
                    pb: 0.5,
                    pt: 0.5,
                }}
            >
                Open New Ticket
            </DialogTitle>
            <DialogContent sx={{pb: 0}}>
                <DialogContentText
                    sx={{
                        textAlign: 'center',
                        fontSize: '0.95rem',
                        color: 'text.secondary',
                    }}
                >
                    We don't want to have this experience for you. Do you want to open a new ticket for this query?
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 1.5,
                    pb: 1,
                    pt: 1
                }}
            >
                <PrimaryButton
                    onTap={onClose}
                    variant="outlined"
                    fullWidth={false}

                    sx={{textTransform: 'none', borderRadius: 2}}
                    text="No"
                />
                <PrimaryButton
                    onTap={onConfirm}
                    text="Yes"
                    sx={{
                        background: ComponentConfig.primaryButtonGradient,
                    }}
                    textStyle={{
                        color: "white",
                        fontSize: ComponentConfig.fonts.subtitleMedium.fontSize,
                        fontWeight: ComponentConfig.fonts.subtitleMedium.fontWeight,
                        textTransform: 'none', borderRadius: 2
                    }}
                    fullWidth={false}
                />
            </DialogActions>
        </Dialog>
    );
};
